<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { computed, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useAuthStore } from '@shared';
import { useDecisionSupportWizardStore } from '../../stores/decision-support-wizard.store';
import { getDecisionSupportChoosableYears } from '../../utils/decision-support.utils';

const router = useRouter();

const decisionSupportWizardStore = useDecisionSupportWizardStore();
const { decisionSupportData, crops } = storeToRefs(decisionSupportWizardStore);

const authStore = useAuthStore();
const { personalData } = storeToRefs(authStore);

const choosableYears = computed(() => getDecisionSupportChoosableYears(personalData.value?.year));

const choosableCrops = computed(() => crops.value.map((crop) => ({ name: crop.name, value: crop.code })));

const isCopy = computed(() => router.currentRoute.value.name === 'decisionSupportWizardCopy');

onMounted(() => {
  if (!isCopy.value) {
    decisionSupportWizardStore.openInfoModal();
  }
});
</script>

<template>
  <div class="h-100 d-flex flex-column align-center justify-center gap-2 align-content-stretch text-center">
    <div class="d-flex w-100">
      <div class="w-40"></div>
      <div class="w-20">
        <h3 class="font-weight-light pb-3">{{ $t('decisionSupport.wizard.label.chooseYear') }}</h3>
        <v-select
          v-model="decisionSupportData.year"
          variant="outlined"
          density="comfortable"
          hide-details
          @update:model-value="decisionSupportWizardStore.onDecisionSupportYearChange"
          :items="choosableYears" />
      </div>
      <div class="w-40 align-content-end text-left">
        <v-icon
          icon="mdi-information"
          id="icon"
          color="blue"
          class="pb-4 pl-6"
          size="x-large"
          @click.stop.prevent="decisionSupportWizardStore.openInfoModal" />
      </div>
    </div>
    <div>
      <h3 class="font-weight-light pb-3">{{ $t('decisionSupport.wizard.label.chooseCrop') }}</h3>
      <v-autocomplete
        v-model="decisionSupportData.metadata.crop"
        variant="outlined"
        density="comfortable"
        item-value="value"
        item-title="name"
        @update:model-value="decisionSupportWizardStore.onDecisionSupportCropChange"
        :items="choosableCrops" />
    </div>
  </div>
</template>
